export const SuggestedQuestionsRoutes = [
  {
    path: ':channel/suggested-questions',
    alias: 'automationSuggestedQuestions',
    lazy: () => import('./SuggestedQuestions.page'),
  },
] as const
